import { applyAttributesFilter as applyAttributesFilterDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

export type ApplyAttributesFilterProps = ApiMethodBase & {
    attribute?: string,
    attributeType?: string,
    mode?: string,
}

export async function applyAttributesFilter ({
    attribute,
    attributeType,
    mode,
    eventEmitter,
}: ApplyAttributesFilterProps) {
    applyAttributesFilterDiagram(attribute, attributeType);
    eventEmitter.emit(Event.applyFilter);
    apiProvider.setDiagramVisualizer()    
    eventEmitter.emit(Event.updateGaugeMetrics);
};
